<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <contractor-organization />
          <checking-accounts v-if="false" />
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import CheckingAccounts from '@/components/CheckingAccounts.vue'
import ContractorOrganization from '@/components/contractor/ContractorOrganization.vue'

export default {
  name: 'InformationAboutContractor',
  components: { ContractorOrganization, CheckingAccounts }
}
</script>
